import { render, staticRenderFns } from "./ProfileHistoryModal.vue?vue&type=template&id=15adf566"
import script from "./ProfileHistoryModal.vue?vue&type=script&lang=js"
export * from "./ProfileHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports